import axios from "axios"

const getWeather = async (latitude: string, longitude: string) => {
  try {
    const res = await axios.get(
      `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&appid=2cf7d2ec777204031976ebed60d1fd92`
    )
    if (res.status !== 200) {
      console.log(res)
      throw new Error("Failed to fetch data")
    } else {
      //   console.log(res)
      const weather = res.data.weather[0]
      const temp = res.data.main
      temp.temp = (temp.temp - 272.15).toFixed(0)
      //   temp.temp_max = (temp.temp_max - 272.15).toFixed(0)
      //   temp.temp_min = (temp.temp_min - 272.15).toFixed(0)
      return { weather: weather.main, temp: temp.temp }
    }
  } catch (e: any) {
    throw new Error(e)
  }
}

export default getWeather
